import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import CustomerAskTheExpertJsx from './roleManage.jsx'

export default class AskTheExpert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryData: null,
            isLoading: false,
            checkedItems: [],
        }
    }

    // Handle change for checkboxes
    handleChange = (data) => {
        const { modulePermissionId, moduleId, checked } = data;
        
        // Update the categoryData to reflect the checkbox state
        const updatedCategoryData = this.state.categoryData.map(module => {
            if (module.moduleId === moduleId) {
                return {
                    ...module,
                    modulePermissions: module.modulePermissions.map(permission => {
                        if (permission.modulePermissionId === modulePermissionId) {
                            return {
                                ...permission,
                                hasPermission: checked
                            };
                        }
                        return permission;
                    })
                };
            }
            return module;
        });

        // Update checkedItems array
        let updatedCheckedItems;
        if (checked) {
            // Add to checkedItems if not already present
            const exists = this.state.checkedItems.some(item => 
                item.modulePermissionId === modulePermissionId && item.moduleId === moduleId
            );
            if (!exists) {
                updatedCheckedItems = [
                    ...this.state.checkedItems,
                    { modulePermissionId, moduleId }
                ];
            } else {
                updatedCheckedItems = this.state.checkedItems;
            }
        } else {
            // Remove from checkedItems
            updatedCheckedItems = this.state.checkedItems.filter(item => 
                !(item.modulePermissionId === modulePermissionId && item.moduleId === moduleId)
            );
        }

        this.setState({
            categoryData: updatedCategoryData,
            checkedItems: updatedCheckedItems
        });
    };

    // Get checked IDs
    getCheckedIds = () => {
        let token = JSON.parse(localStorage.getItem('token'));

        const data = {
            "roleName": "Admin Role",
            "access": "read/write",
            "modules": this.state.checkedItems
        }
        
        this.setState({ isLoading: true })

        axios.post(`${baseURL}/role`, data, {
            headers: {
                'x-access-token': token
            }
        }).then(res => {
            this.setState({ blogData: res.data, isLoading: false });
        }).catch(err => {
            this.setState({ isLoading: false })
            toast.error(err.response.data.error.message)
          })
    };

    componentDidMount = () => {
        this.setState({ isLoading: true })
        let token = JSON.parse(localStorage.getItem('token'));
        
        axios.get(`${baseURL}/modules`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            const categoryData = res.data.data;
            
            // Initialize checkedItems with permissions that have hasPermission: true
            const initialCheckedItems = [];
            categoryData.forEach(module => {
                module.modulePermissions.forEach(permission => {
                    if (permission.hasPermission) {
                        initialCheckedItems.push({
                            modulePermissionId: permission.modulePermissionId,
                            moduleId: module.moduleId
                        });
                    }
                });
            });

            this.setState({ 
                categoryData: categoryData, 
                checkedItems: initialCheckedItems,
                isLoading: false 
            });
        }).catch(err => {
            this.setState({ isLoading: false });
        });
    }

    render() {
        return (
            <div>
                <CustomerAskTheExpertJsx
                    categoryData={this.state.categoryData}
                    getCheckedIds={this.getCheckedIds}
                    handleChange={this.handleChange}
                />
                {this.state.isLoading && <Loader />}
                <ToastContainer />
            </div>
        )
    }
}